/* Built In Imports */
import NextLink from 'next/link';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

/* External Imports */
import {
  Box,
  Flex,
  Icon,
  Link,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
// import copy from 'copy-to-clipboard';
import { render } from 'datocms-structured-text-to-html-string';
import filter from 'lodash/filter';
import { nanoid } from 'nanoid';
import { useRouter } from 'next/router';

/* Internal Imports */
/* Components */
import { ChevronRightIcon } from '@chakra-ui/icons';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import config from '@config';
import { usePageType } from '@hooks/usePageType';
import { ProgramFeeSt } from '@ieo/Common/CompLangConfig';
import { gtmObject } from '@ieo/Components/Form/ieo/api/analyticsAPi';
import { useProgramLanguageSelection } from '@ieo/Components/Form/ieo/context/programLanguageSelectionContext';
import { programTypes } from '@ieo/Components/Form/ieo/utils';
import { usePageConfigValue } from '@ieo/hooks/usePageConfigVal';
import { useMediaQuery } from 'react-responsive';

/* Services */
/* Styles */

/**
 *
 * @param {Object} prgData
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @param {Object} pageData
 * @returns ProgramFee
 */
const IeoProgramFeesCorporates = ({
  sectionContent,
  region,
  lang,
  prgData,
  pageData,
}) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const pathname = usePathname();
  // const [isOpen, setIsOpen] = useState(false);
  const priceData = Object?.values(prgData || '');
  const [isGiftingFlow, setIsGiftingFlow] = useState();
  const { setProgramLanguage } = useProgramLanguageSelection();
  // const transProviderObj =
  //   (pageData._allSharedJsonLocales?.length &&
  //     pageData._allSharedJsonLocales[0]?.value.json) ||
  //   pageData.sharedJson?.json;
  const { isGiftPage } = usePageType();
  // const additionalText = sectionContent?.find(
  //   e => e.fieldId === 'additional-off'
  // );
  const currentCoupon = Object.values(prgData)[0]?.coupon;

  const { pageConfigVal, isThemeActive } = usePageConfigValue(
    pageData,
    region,
    currentCoupon
  );

  const programHeading = sectionContent?.find(
    e => e.fieldId === 'language-heading'
  );
  const untilText = sectionContent?.find(e => e.fieldId === 'offer-until');
  const router = useRouter();
  const isLandingOrPcPage =
    region === 'in' &&
    (router.asPath?.split('?')[0].endsWith('inner-engineering-pc') ||
      router.asPath?.split('?')[0].endsWith('inner-engineering'));

  // const isUS = pageData?.country === 'US';
  // const isCA = pageData?.country === 'CA';

  const gtmClick = (lang, price) => {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'IE_Language_Selected',
        IE_Lang: lang,
        IE_LP_Location: 'Language_Table',
      });

      window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      window.dataLayer.push({
        event: 'add_to_wishlist',
        ecommerce: {
          currency: 'INR', // currency code (Ex - INR,USD,AUD etc.)
          value: price || priceData[0].discountedPrice || '',
          items: [
            {
              item_id: programTypes.IEO, // id of the program
              item_name: isGiftPage
                ? 'Gift Inner Engineering'
                : 'TYLS Inner Engineering', // Name of the program (Ex - TYLS Inner Engineering)
              affiliation: '',
              coupon: '',
              discount: 0, //Actual Discount if any (actual price - pay price)
              index: '',
              item_brand: '', // Country Code (Ex - US,IN etc.)
              item_category: '', // Language (Ex - English,Spanish etc.)
              item_category2: '', // Bay Name (not reuired for IE)
              item_category3: '', // New_User or Repeat_User
              item_category4: 'Language_Table',
              item_category5: '',
              item_list_id: '',
              item_list_name: '',
              item_variant: '',
              location_id: '',
              price: price || priceData[0].discountedPrice || '',
              quantity: '',
            },
          ],
        },
      });

      gtmObject({
        event: isGiftPage ? 'IE_Gift_Inner_Engineering' : 'IE_Register_Now',
        IE_LP_Location: 'Sticky_CTA',
        event1: 'view_item',
        item_name: isGiftPage
          ? 'Gift Inner Engineering'
          : 'TYLS Inner Engineering',
        item_category4: 'Language_Table',
      });
    }
  };
  let PriceDataList = [];
  if (region === 'in') {
    config.orderedLangList[lang].forEach(language => {
      const price = priceData.filter(item => {
        return item.lang === language.toUpperCase();
      });
      if (price.length > 0) {
        PriceDataList.push(price[0]);
      }
    });
  } else {
    PriceDataList = [...priceData];
  }
  const isIndian = region === 'in';
  // const changeUi = !isIndian;
  const changeUi =
    router.asPath.indexOf('inner-engineering-pc') > 0 && isIndian;
  const [discountText, setDiscountText] = useState({});

  useEffect(() => {
    if (priceData?.length) {
      let filteredText = filter(pageConfigVal?.discounText, function (item) {
        return (
          item.code === priceData[0].coupon?.couponCode &&
          item.lang?.toLowerCase() === lang.toLowerCase()
        );
      });
      if (filteredText?.length) {
        setDiscountText(filteredText[0]);
      }
    }
  }, [priceData]);

  useEffect(() => {
    if (router.asPath.indexOf('/gift') > -1) {
      setIsGiftingFlow(true);
    }
  }, [router.asPath]);

  return (
    <Box bg={`url(${sectionContent[12]?.image?.url})  no-repeat #F1EBDF`}>
      <Flex
        maxW={1030}
        bgRepeat="no-repeat"
        pt={{ base: '60px', md: '50px' }}
        id="ieo-program-fees"
        mx="auto"
      >
        <Flex
          w="full"
          mx="auto"
          flexWrap="wrap"
          px={{ base: changeUi ? '0' : '16px', xl: 0 }}
          pt={{
            base: '0px',
            md: lang === 'ar' ? '30px' : '80px',
            xl: '60px',
          }}
        >
          {/* Heading */}
          {programHeading && (
            <StructuredTextParser
              str={render(programHeading?.body)}
              fontSize={{ base: '1.625rem', md: '3.125rem' }}
              lineHeight={{ base: '2.11rem', md: '4.25rem' }}
              fontFamily="FedraSansStd-medium"
              textAlign="center"
              maxW={{ base: '100% !important', md: '70% !important' }}
              mb={8}
              mx="auto"
              className="heading_lang"
            />
          )}
          {sectionContent?.[1]?.table && prgData && (
            <Flex w="full" py={{ base: '30px', md: '80px' }}>
              <TableContainer
                whiteSpace="pre-wrap"
                bg="#fff"
                w="full"
                fontFamily="FedraSansStd-medium"
                boxShadow="0 10px 10px -6px #cbc7bb"
              >
                <Table variant="striped" colorScheme="blackAlpha">
                  <Thead bg="#B49168">
                    <Tr>
                      {sectionContent?.[1]?.table?.columns?.map(
                        (column, index) => (
                          <Th
                            display={{
                              base:
                                changeUi && index === 1 ? 'none' : 'table-cell',
                              md: 'table-cell',
                            }}
                            key={nanoid()}
                            textAlign="left"
                            {...ProgramFeeSt[lang].tableHead}
                            color="#fff"
                            lineHeight={{ base: '26px', xl: 'normal' }}
                            px={{ base: '16px', lg: '50px' }}
                            py={{ base: '15px', md: '30px' }}
                            textTransform="none"
                          >
                            {column}
                          </Th>
                        )
                      )}
                    </Tr>
                  </Thead>
                  <Tbody>
                    {PriceDataList?.map((item, index) => (
                      <Tr key={index}>
                        <Td
                          px={{ base: '16px', lg: '50px' }}
                          lineHeight={{ base: '26px', xl: 'normal' }}
                          color="#6D6358"
                          {...ProgramFeeSt[lang].bodyTd}
                        >
                          {item['lang'] &&
                            config.lngList[item['lang']?.toLowerCase()]}
                        </Td>
                        {/* {changeUi && (
                          <Td
                            px={{ base: '16px', lg: '50px' }}
                            display={{ base: 'none', md: 'table-cell' }}
                          >
                            <Text
                              as="del"
                              textDecor="line-through"
                              lineHeight={{ base: '26px', xl: 'normal' }}
                              color="#6D6358"
                              {...ProgramFeeSt[lang].bodyTd}
                            >
                              {isIndian && item['curr']} {item['pgmFee']}
                              {item['pgmFee']}
                            </Text>
                          </Td>
                        )} */}
                        <Td
                          px={{ base: '16px', lg: '50px' }}
                          lineHeight={{ base: '26px', xl: 'normal' }}
                          color="#6D6358"
                          {...ProgramFeeSt[lang].bodyTd}
                        >
                          {/* uncomment to add price with discounted price in mobile */}
                          <Text
                            as="del"
                            textDecor="line-through"
                            lineHeight={{ base: '26px', xl: 'normal' }}
                            color="#6D6358"
                            display={{
                              base: changeUi ? 'auto' : 'none',
                              md: 'none',
                            }}
                            {...ProgramFeeSt[lang].bodyTd}
                          >
                            {isIndian && item['curr']} {item['pgmFee']}
                          </Text>
                          <Text>
                            {/* comment the below code to add inr */}
                            {item?.coupon ? (
                              <>
                                {item?.curr} {item?.coupon?.postCouponPrice}
                              </>
                            ) : (
                              <>
                                {isIndian && item['curr']}{' '}
                                {item['discountedPrice']}
                              </>
                            )}
                          </Text>
                        </Td>
                        {sectionContent?.[1]?.table?.columns.indexOf(' ') !==
                          -1 && (
                          <Td
                            px={{ base: '16px', lg: '50px' }}
                            lineHeight={{ base: '26px', xl: 'normal' }}
                            color="#6D6358"
                            wordBreak="auto-phrase"
                            {...ProgramFeeSt[lang].bodyTd}
                          >
                            <NextLink
                              href="#ieo-enroll-section"
                              //href={disabled ? '#' : currentUrl}
                              passHref
                              legacyBehavior
                            >
                              <Link
                                color="#F37021"
                                display="flex"
                                _hover={{ color: '#BC570F' }}
                                onClick={() => {
                                  // console.log('Called onClick', item.lang);
                                  setProgramLanguage(item.lang);
                                  gtmClick(item.lang, item['discountedPrice']);
                                }}
                              >
                                <Flex alignItems="center">
                                  {pathname.indexOf('inner-engineering-v4') > -1
                                    ? 'Start My Transformation'
                                    : isMobile
                                    ? 'Register'
                                    : 'Register Now'}
                                  <Icon
                                    as={ChevronRightIcon}
                                    width="24px"
                                    height="24px"
                                  />
                                </Flex>
                              </Link>
                            </NextLink>
                          </Td>
                        )}
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </TableContainer>
            </Flex>
          )}
        </Flex>
        <style global>
          {`
            .thanksgiving:hover svg {
              fill: #E86F34;
              color: #E86F34;
            }
            .thanksgiving:hover {
              background: '#FAE4B8';
              color: '#FFFFFF';
            }
            
            .lang-blue-text p mark {
              color:#3652B8;
              background:none;
              font-weight:600
            }      
            .heading_lang h2{
              color:#F37021
              }
              .heading_lang mark{
                background: none;
                color:#12166F
            }
              `}
        </style>
      </Flex>
    </Box>
  );
};

export default IeoProgramFeesCorporates;
